__turbopack_context__.v({
  ":popover-open": "X-5gbG_:popover-open",
  "panel": "X-5gbG_panel",
  "panelBottom": "X-5gbG_panelBottom",
  "panelTop": "X-5gbG_panelTop",
  "triggerDesktop": "X-5gbG_triggerDesktop",
  "triggerMobile": "X-5gbG_triggerMobile",
});
